<template>
    <div class="app-container">
      <BjPage
        ref="BjPage"
        :query-params="queryParams"
        :col-span="colSpan"
        :label-width="'80px'"
        :get-action="queryApi"
        :serial="serial"
        :selection="selection"
        @handleSelectionChange="handleSelectionChange"
        @showSetting="SortableTable.show"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('RoleManagement.common.RoleName')" prop="name">
              <BjInput
                v-model="queryParams.name"
                :maxlength="20"
                :placeholder="$t('RoleManagement.common.RoleName')"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('RoleManagement.common.Status')" prop="enabled">
              <BjSelectLov
                v-model="queryParams.enabled"
                :option-list="STATUS_ENABLED_TRUE"
                :placeholder="$t('RoleManagement.common.Status')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('RoleManagement.common.describe')" prop="description">
              <BjInput v-model="queryParams.description" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('RoleManagement.common.describe')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan" v-if="!$store.getters.cusId">
            <el-form-item :label="$t('AccountManagement.common.belongto')" prop="belongTo">
              <BjSelectLov v-model="queryParams.belongTo" :clearable="false" :option-list="STATUS_ENABLED_TRUES" :placeholder="$t('AccountManagement.common.belongto')"/>
            </el-form-item>
          </el-col>
          <el-col v-if="!$store.getters.cusId && queryParams.belongTo==2" :span="colSpan">
            <el-form-item :label="$t('customerNameText')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
          </el-col>
          <!-- css空壳 -->
          <el-col v-if="!$store.getters.cusId && queryParams.belongTo==1" :span="colSpan">
            <div style="width: 30px; height: 10px"></div>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button
              type="primary"
              class="main-btn"
              @click="addRole(1)"
              >{{ $t('RoleManagement.common.create') }}</el-button
            >
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column
              v-if="col.prop !== 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || false"
              align="center"
              class-name="item"
            >
              <template slot-scope="scope">
                <template v-if="false" />
                <el-tag
                  v-else-if="col.prop === 'enabled'"
                  :type="scope.row.enabled ? 'success' : 'info'"
                  >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.enabled)) }}</el-tag
                >
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="col.prop === 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || 'right'"
              align="center"
            >
              <template slot-scope="props">
                <el-button
                  type="text"
                  class="edit-btn"
                  @click="addRole(2, props.row)"
                  >{{ $t('editText') }}</el-button
                >
                <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, props.row)">
                  <span class="el-dropdown-link">
                    {{ $t('table.operationText') }}<i class="el-icon-arrow-down el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-if="props.row.enabled"
                      :command="$t('disableText')"
                      >{{ $t('disableText') }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="!props.row.enabled"
                      :command="$t('enableText')"
                      >{{ $t('enableText') }}</el-dropdown-item
                    >
                    <!-- <el-dropdown-item command="分配权限">分配权限</el-dropdown-item> -->
                    <el-dropdown-item :command="$t('RoleManagement.common.users')"
                      >{{ $t('RoleManagement.common.users') }}</el-dropdown-item
                    >
                    <el-dropdown-item :command="$t('RoleManagement.common.menu')"
                      >{{ $t('RoleManagement.common.menu') }}</el-dropdown-item
                    >
                    <el-dropdown-item :command="$t('RoleManagement.common.Log')"
                      >{{ $t('RoleManagement.common.Log') }}</el-dropdown-item
                    >
                    <!-- <el-dropdown-item command="分配数据权限">分配数据权限</el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="title"
        :visible.sync="addDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form" :model="form" status-icon :rules="rules" label-width="100px">
          <el-form-item :label="$t('RoleManagement.common.RoleName')" prop="name">
            <BjInput v-model="form.name" :maxlength="20" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item :label="$t('RoleManagement.common.describe')" prop="describe">
            <BjInput
              v-model="form.description"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="title"
        :visible.sync="rolePermissionDialogVisible"
        width="600px"
        :before-close="handleClose"
      >
        <div class="dialog-custom-class-body-div">
          <el-tree
            ref="tree"
            :data="rolePermissionList"
            show-checkbox
            default-expand-all
            node-key="id"
            highlight-current
            :props="defaultProps"
          >
            <template slot-scope="{ node, data }">
              <div>
                {{ node.label }}
                <el-tag v-if="data.permissionType == 'button'" type="warning">{{ $t('RoleManagement.common.button') }}</el-tag>
                <el-tag v-if="data.permissionType == 'api'">API</el-tag>
              </div>
            </template>
          </el-tree>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleConfirmRolePermission">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { roleApi } from '@/api';
  import { STATUS_ENABLED_TRUE,STATUS_ENABLED_TRUES } from '@/utils/constants';
  import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
  export default {
    name: 'BusinessUserRoleAdminCSG',
    components: { BjSelectCustomer },
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        selection: false,
        queryApi: roleApi.getRoleList,
        STATUS_ENABLED_TRUE,
        STATUS_ENABLED_TRUES,
        // 查询参数
        queryParams: {
          enabled: null,
          belongTo: this.$store.getters.cusId ? 2:1,
          name: null,
          cusId: null,
        },
        title: '',
        addDialogVisible: false,
        rolePermissionDialogVisible: false,
        // 表单参数
        form: {
          name: null,
          description: null,
          id: null,
          _token: null,
          objectVersionNumber: null,
        },
        // 表单校验
        rules: {
          name: [{ required: true, message: this.$t('RoleManagement.common.ps'), trigger: 'blur' }],
        },
        labelList1: [
          { label: this.$t('RoleManagement.table.RoleName'), prop: 'name', isCheck: true, disabled: false },
          { label: this.$t('RoleManagement.table.tenantName'), prop: 'tenantName', isCheck: true, disabled: false },
          { label: this.$t('customerNameText'), prop: 'createdUserName', isCheck: true, disabled: false },
          { label: this.$t('RoleManagement.table.Status'), prop: 'enabled', isCheck: true, disabled: false },
          { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false },
          { label: this.$t('RoleManagement.common.describe'), prop: 'description', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 160 },
        ],
        rolePermissionList: [
          {
            id: '',
            code: 'skyer.site.sys',
            name: this.$t('loadingText'),
            parentId: '0',
            type: 'root',
            sort: 10,
            permissionType: 'api',
            subMenus: [],
            viewCode: 'sys',
            rootNode: false,
          },
        ],
        defaultProps: {
          children: 'subMenus',
          label: 'name',
        },
        isEdit: false,
        selectedRow: null,
        defaultCheckedRolePermissionList: [],
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'createdUserName') : this.labelList1;
      },
    },

    created() {},
    mounted() {},
    methods: {
      reFresh(n = 1) {
        this.$refs.BjPage.fetchData(n);
      },
      addRole(type, row) {
        this.title = type === 1 ? this.$t('RoleManagement.common.create') : this.$t('RoleManagement.common.editsome');
        this.addDialogVisible = true;
        if (type === 1) {
          this.isEdit = false;
          this.title = this.$t('RoleManagement.common.create');
          this.form.id = null;
          this.form.name = null;
          this.form.code = null;
          this.form.description = null;
          this.form._token = null;
          this.form.objectVersionNumber = null;
        }
        if (type === 2) {
          this.isEdit = true;
          this.title = this.$t('RoleManagement.common.editsome');
          this.form.id = row.id;
          this.form.name = row.name;
          this.form.code = row.code;
          this.form.description = row.description;
          this.form._token = row._token;
          this.form.objectVersionNumber = row.objectVersionNumber;
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      handleSelectionChange(data) {
      },

      switchRoleAbled(API_KEY, data) {
        roleApi[API_KEY](data)
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
            }
            this.reFresh();
          });
      },
      command(TEXT, row) {
        this.selectedRow = row;
        if (TEXT === this.$t('disableText') || TEXT === this.$t('enableText')) {
          this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              this.switchRoleAbled(TEXT === this.$t('enableText') ? 'enableRole' : 'disableRole', {
                id: row.id,
                objectVersionNumber: row.objectVersionNumber,
                _token: row._token,
              });
            })
            .catch(() => {});
        }

        if (TEXT === this.$t('RoleManagement.common.users')) {
          this.$router.push({
            name: 'BusinessUserRoleAllotUserCSG',
            query: {
              roleId: row.id,
              roleName: row.name,
              roleCode: row.code,
              belongTo: row.cusId ? 2:1
            },
          });
        }

        if (TEXT === this.$t('RoleManagement.common.menu')) {
          this.$router.push({
            name: 'BusinessUserRoleAllotMenuCSG',
            query: {
              roleId: row.id,
            },
          });
        }

        if (TEXT === this.$t('RoleManagement.common.Log')) {
          this.$operateLogs({
            title: `${row.name}${this.$t('RoleManagement.common.Log')}`,
            defaultQuery: {
              recordId: row.id,
            },
            api: 'roleApi',
          });
        }
      },
      getPermissionTreeByRoleId(roleId) {
        roleApi
          .getPermissionTreeByRoleId({
            roleId: roleId,
          })
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.rolePermissionList = res || [];
              this.$nextTick(() => {
                this.setCheckedKeys(this.rolePermissionList);
              });
            }
          });
      },
      /* **********************新建角色部分************************** */
      /**  */
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (!valid) return this.$scrollToFormError();
          //     currentRoleId: "1"
          // currentRoleLevel: "site"

          const data = {
            _innerMap: {},
            code: this.form.code,
            description: this.form.description,
            name: this.form.name,
          };
          let API_KEY = 'createRole';
          if (this.isEdit && this.form.id !== null) {
            data['id'] = this.form.id;
            data['_token'] = this.form._token;
            data['objectVersionNumber'] = this.form.objectVersionNumber;
            API_KEY = 'updateRole';
          } else {
            // TODO: 创建时，需要父级角色
            data['parentRoleId'] = this.$store.getters.userInfo.currentRoleId;
          }
          roleApi[API_KEY](data)
            .then(res => {
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                this.addDialogVisible = false;
                this.reFresh();
              } else {
                if (res.code === 'error.role.name.exist') {
                  this.$message.error(this.$t('RoleManagement.roleNameExists') || 'Error message not find');
                } else {
                  this.$message.error(res.message || 'Error message not find');
                }
              }
            });
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.addDialogVisible = false;
        this.rolePermissionDialogVisible = false;
      },
      handleConfirmRolePermission() {
        this.updatePermissionTreeByRoleId(this.selectedRow.id);
      },
      updatePermissionTreeByRoleId(roleId) {
        const oldChecked = this.defaultCheckedRolePermissionList;
        const newChecked = this.getCheckedKeys();
        const addFilter = newChecked.filter(nid => {
          return oldChecked.indexOf(nid) === -1;
        });
        const removeFilter = oldChecked.filter(nid => {
          return newChecked.indexOf(nid) === -1;
        });
        const promise1 = roleApi.recyclePermissionTreeByRoleId({
          roleId: roleId,
          BjBody: removeFilter,
        });
        const promise2 = roleApi.assignPermissionTreeByRoleId({
          roleId: roleId,
          BjBody: addFilter,
        });

        Promise.all([promise1, promise2])
          .then(values => {
            const [res1, res2] = values;
            if (res1 && !res1.failed && res2 && !res2.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
            }
            this.handleClose();
          });
      },
      setCheckedKeys() {
        const filterIds = [];
        const fn = arr => {
          arr.forEach(element => {
            if (element.checkedFlag == 'Y') {
              filterIds.push(element.id);
            }
            if (element.subMenus && element.subMenus.length) {
              fn(element.subMenus);
            }
          });
        };
        fn(this.rolePermissionList);
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys(filterIds);
          this.defaultCheckedRolePermissionList = [].concat(filterIds);
        }, 100);
      },
      getCheckedNodes() {
        return this.$refs.tree.getCheckedNodes();
      },
      getCheckedKeys() {
        return this.$refs.tree.getCheckedKeys();
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .dialog-custom-class-body-div {
    max-height: calc(85vh - 120px);
    overflow-y: scroll;
  }
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
